import styled from "styled-components";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { links } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { External } from "~/components/atoms";
import type { PropsWithChildren } from "react";
import Label from "../Label";
import Card from "./Card";
import Detail from "./Detail";
import Info from "./Info";

const WrapperPartial = styled.div`
  width: ${(props) => props.theme.sizes.summary};
`;

const Container = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.dark200};
    overflow: hidden;
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.colors.border};
`;

const Top = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    min-height: ${(props) => props.theme.sizes.buttonMini};
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
`;

const Title = styled.div`
  flex: 1;
  & > h2 {
    ${(props) => props.theme.styles.textMenu}
  }
`;

const Extra = styled(External)`
  ${(props) => props.theme.styles.row}
  & {
    * {
      cursor: pointer !important;
      &:hover,
      &:active {
        label {
          text-decoration: underline;
        }
      }
    }
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxLG} {
    width: 100%;
    ${Container} {
      padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    }
  }
`;
interface Props {
  className?: string;
}

function Section({ className, children }: PropsWithChildren<Props>) {
  const { t } = useT();
  return (
    <Wrapper className={className}>
      <Top>
        <Title>
          <h2>{t("words.summary")}</h2>
        </Title>
        <Extra to={links.docs.v2}>
          <Label
            icon={InformationCircleIcon}
            isIconLast
            value={t("structs.guideAndDetails")}
          />
        </Extra>
      </Top>
      <Container>{children}</Container>
    </Wrapper>
  );
}

const Summary = {
  Card,
  Detail,
  Divider,
  Info,
  Section,
};

export default Summary;
